import type { SkedEnvConfig } from "./types";

const config: SkedEnvConfig = {
  resourceUrl: "https://assets-prod.skedsocial.com/",
  apiBaseUrl: "",
  fbAppId: "177460866310014",
  fbGraphApiVersion: "v25.0",
  fbBusinessLoginAppId: "177460866310014",
  sendBirdAppId: "13069A74-7FB0-45D9-BC05-B2DF4F172307",
  amplitudeKey: "b9fffa187362da24a877793990facd0e",
  amplitudeExperimentDeploymentKey: "client-sZa7yiXghmkmSTA7Y2ZZ4bh54f3VfiJY",
  hubspotId: "44300864",
  bingPixelId: "17420662",
  linkedInPartnerId: "478874",
  pinterestTagId: "2613969021991",
  googleAdsId: "AW-992177465",
  ga4MeasurementId: "G-5X8LYXP673",
  gtmContainerId: "GTM-5WV4CJM",
  bugsnagApiKey: "8f449d48646c0c521405dbb8b900217d",
  canvaApiKey: "fG32Ux1dYsPxhWU6QraYRH4x",
  dropboxAppKey: "7cwt9g746b3z3qa",
  chargebeeEnabled: true,
  analyticsEnabled: true,
  observabilityEnabled: true,
  observabilityEndpoint:
    "https://ooingest.skedsocial.com/api/3EL1FezMtKzFcnurkYQCXvcfAUW/v1/traces",
  observabilityHeaders: {
    Authorization:
      "Basic b28taW5nZXN0LWZyb250ZW5kLXByb2RAc2tlZHNvY2lhbC5jb206WmJDNm5rbm9IQTZFOWdDUA==",
    organization: "3EL1FezMtKzFcnurkYQCXvcfAUW",
    "stream-name": "default",
  },
  observabilitySampleRate: 0.1,
  rumClientToken: "rumfWL0KAgIrZ7qsWt0",
  rumOrgIdentifier: "3EL1FezMtKzFcnurkYQCXvcfAUW",
  rumSessionSampleRate: 20,
  rumSessionReplaySampleRate: 10,
  knockApiKey: "pk_HNjorVDYqjDWnGOtrBnSCuOgtl9xgok6vR7xyAx9Woc",
  cesdkAssetsUrl:
    "https://assets-prod.skedsocial.com/resources/build/cesdk-assets",
  googleDriveClientId:
    "370773354305-phvrijjkhv4vf3gvcqd582q8p48mdj8t.apps.googleusercontent.com",
  googleDriveAppId: "370773354305",
  pusherApiKey: "4545a9bbfd763f756e38",
  pusherCluster: "mt1",
  insightsApiBaseUrl: "https://api-insights-2.skedsocial.com/api",
  insightsShareDomain: "https://insights-share.skedsocial.com",
};

export default config;
